<template>
    <ValidationObserver ref="observer">
        <section class="padding-vertical-content lightgray-content mb-3 mb-lg-4" id="paso-3">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="mb-4 h3 text-uppercase">Resumen de compra</div>
                        <div class="padding-content white-content mb-2">
                            <div class="padding-content bg-light">
                                <ResumenCompraComponent :items="[base.categoria_base]"
                                    v-on:isAccepted="conditions_accepted_handler" style="margin: 50px">
                                </ResumenCompraComponent>
                            </div>
                            <div v-if="are_conditions_accepted" class="mt-3">
                                <b-card-text>
                                    Si es de nueva inscrpción, la información que deben adjuntar los padres son:
                                    <ul>
                                        <li><b>DNI/NIE/Pasaporte (Ambas caras) Jugador</b></li>
                                        <li>
                                            <b>DNI/NIE/Pasaporte (Ambas caras) de los
                                                responsables</b>
                                        </li>
                                    </ul>
                                </b-card-text>
                                <vue-dropzone 
                                    v-model="base.fotos_dni" 
                                    ref="myVueDropzone" 
                                    id="dropzone"
                                    v-on:vdropzone-success="vdropzone_success_handler"
                                    :options="dropzoneOptions"
                                >
                                </vue-dropzone>
                                <div id="formulario-compra" v-html="formulario"></div>
                                <div v-if="show == true" class="mt-4">
                                    <button type="submit" name="button" class="button effect-button large-button"
                                        @click="submit()">
                                        <span>Terminar</span>
                                    </button>
                                </div>
                            </div>
                            <b-card v-else bg-variant="info" style="margin: 20px">
                                <b-card-text>
                                    Es necesario aceptar las condiciones de uso antes de
                                    continuar.
                                </b-card-text>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </ValidationObserver>
</template>

<script>
import ResumenCompraComponent from "@/components/frontend/bases/ResumenCompraComponent";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
    props: ["base", "items"],
    created() {
        this.dropzoneOptions["url"] =
            this.config.API_BASE +
            "/f/upload/documento" +
            "?tipo=bases&id=" +
            this.base["dni"];
    },
    data() {
        return {
            formulario: null,
            are_conditions_accepted: false,
            show: true,
            dropzoneOptions: {
                url: null,
                thumbnailWidth: 150,
                maxFilesize: 5,
                dictDefaultMessage: "Arrastra aquí tus ficheros",
            },
            documentos_id: []
        };
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        }
    },
    methods: {
        conditions_accepted_handler(value) {
            this.are_conditions_accepted = value;
        },
        submit() {
            this.cargarFormularioPago();
            (this.show = false), this.$emit("terminado");
        },
        cargarFormularioPago() {
            let path = this.$router.resolve({ name: "front.bases.crear" }).href;
            let fullUrlSuccess = window.location.origin + path + "?error=no";
            let fullUrlFailure = window.location.origin + path + "?error=si";
            this.base["filters"] = {
                tid: this.configuracion.hash_teatro,
            };
            this.base["url_success"] = fullUrlSuccess;
            this.base["url_failure"] = fullUrlFailure;
            this.base["tid"] = this.configuracion.hash_teatro;
            this.base["lista_abonado_id"] = this.lista_abonados.id;
            this.base['categoria_base'] = this.base['categoria_base']['id'];
            this.base['documentos_id'] = this.documentos_id;

            this.$store
                .dispatch(
                    this.config.getVuexAlias("back.formulario.pago.bases"),
                    this.base
                )
                .then(res => {
                    this.formulario = res.data.formulario;
                });
        },
        vdropzone_success_handler(file, response) {
            this.documentos_id.push(response.documento_id);
        },
    },
    components: {
        ResumenCompraComponent,
        vueDropzone: vue2Dropzone,
    },
};
</script>